import { render, staticRenderFns } from "./DivisionInterns.vue?vue&type=template&id=43996a4c&scoped=true"
import script from "./DivisionInterns.vue?vue&type=script&lang=ts"
export * from "./DivisionInterns.vue?vue&type=script&lang=ts"
import style0 from "./DivisionInterns.vue?vue&type=style&index=0&id=43996a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43996a4c",
  null
  
)

export default component.exports